export default "__VITE_ASSET__QsSuXgOE__"